import React, { useEffect, useState } from "react";
import { RouterProvider } from "react-router-dom";
import router from "routes";
import { AppProvider } from "contexts/AppContext";
import useApp from "hooks/useApp";
import { ApolloProvider } from "@apollo/client";
import client from "utils/apollo";
import { CSRFProvider } from "contexts/CSRFContext";
import { ToastContainer } from "react-toastify";
import "styles";
import InternetSpeedMeter from "components/InternetSpeedMeter";
import { initDB } from "react-indexed-db-hook";
import { DBConfig } from "DBConfig";

initDB(DBConfig);

function App() {
  //contexts
  const { appState, setAppState } = useApp();

  return (
    <React.Fragment>
      <CSRFProvider>
        <ApolloProvider client={client}>
          <AppProvider value={{ appState, setAppState }}>
            <InternetSpeedMeter />
            <ToastContainer
              newestOnTop
              closeOnClick={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              position="top-right"
              autoClose={5000}
              hideProgressBar={false}
              theme="light"
            />
            <RouterProvider router={router} />
          </AppProvider>
        </ApolloProvider>
      </CSRFProvider>
    </React.Fragment>
  );
}

export default App;
